import MemoryAllocationInput from './MemoryAllocationInput';

export default MemoryAllocationInput;
